import { Optional, Type } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';

import { AlertService } from '../alert.service';
import { CaseService } from '../case/case.service';
import { MemberService } from '../member/member.service';
import { ProductContextService } from '../product-context/product-context.service';
import { UserService } from '../user/user.service';
import { BaseProductService } from './-base-product.service';
import { IProductContextCase, ProductCategoryNames } from './../../models/case';
import { BaseProductInterviewData } from './_base-product-interview-data';
import { BaseProductStateModel } from './base-product-state.models';
import { AssessmentType } from 'src/app/shared/interview-new/models/interview.models';
import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';


export abstract class BaseProductServiceSingle<T extends BaseProductStateModel> extends BaseProductService<T> {



    constructor(
        @Optional() public productCategory: keyof typeof ProductCategoryNames,
        public memberService: MemberService,
        userService: UserService,
        caseService: CaseService,
        protected productContextService: ProductContextService,
        public confirmationService: ConfirmationService,
        public router: Router,
        public route: ActivatedRoute,
        protected alertService: AlertService,
        interviewDataType: Type<BaseProductInterviewData>,
        protected store: Store,
        featureService: FeatureService,
        interviewHandler: InterviewHandlerService,
        taskOrchestratorService: TaskOrchestratorService
    ) {
        super(
            productCategory,
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            interviewDataType,
            store,
            featureService,
            interviewHandler,
            taskOrchestratorService
        );

    }

    async ngxsAfterBootstrap() {
        await super.ngxsAfterBootstrap();
    }

    async getOrAddCase(assessmentType?: AssessmentType): Promise<IProductContextCase> {
        const productCase = await this.getCaseAsync();

        if (await this.shouldCreateCase(productCase, assessmentType)) {
            return await this.addCase().pipe(first()).toPromise();
        }

        return Promise.resolve(productCase);
    }

}
